define(function (require, exports, module) {
    var EventMap = require('./DatasourceToEventMap');
    var SubsManager = require('../control/SubscriptionManager');
    var datasourceDefinitions = {};

    exports.datasourceDefinitions = datasourceDefinitions;

    exports.setDatasourceNames = function (srcs) {
        var initSubs = [];
        var prop;
        var upperProp;

        for (prop in srcs) {
            upperProp = prop.toUpperCase();
            datasourceDefinitions[prop] = srcs[prop];
            exports[upperProp] = prop;
            EventMap[upperProp] = prop;
            initSubs.push(prop);
        }

        SubsManager.establishInitSubscribes(initSubs);
    };
});
